import React from 'react';
import styled from 'styled-components/macro';
import { responsive } from '../../resources/constantes.json';
import {
  LogoRegistraduria,
  LogoRegistraduriaLeft,
  LogoRegistraduriaRight,
} from '../../assets/img';
import { useIsMobile } from '../../hooks/useMediaQuery';
/**
 *  Lista de checkbox que permite elegir entre varias opciones. Se utiliza en la pantalla
 * de estadísitcas para elegir entre distintos tipos de estadísticas.
 */

const FooterLayout = () => {
  const isMobile = useIsMobile();
  return (
    <FooterContainer>
      <SLogoRegistraduria>
        <img
          style={{ width: '135px', alignSelf: 'center' }}
          src={LogoRegistraduriaLeft}
          alt={'Logo registraduria'}
        />
        {!isMobile ? (
          <div
            style={{
              justifySelf: 'stretch',
              width: '3px',
              backgroundColor: '#D8DFEA',
              margin: '0 40px',
            }}
          />
        ) : <div
          style={{
            width: '100%',
            height: '2px',
            backgroundColor: '#D8DFEA',
          }}
        />}
        <img
          style={{ height: '60px', alignSelf: 'center' }}
          src={LogoRegistraduriaRight}
          alt={'Logo registraduria'}
        />
      </SLogoRegistraduria>
      <SPrint >
        <img
          src={LogoRegistraduria}
          alt={'Logo registraduria'}
        />
      </SPrint>
      <div>
        <TextContainer>
          <p>
            De conformidad con el parágrafo 2 del artículo 2 de la Resolución
            No. 1706 de 2019 del CNE, los boletines expedidos por la
            Registraduría Nacional del Estado Civil, durante el denominado
            preconteo, no son de carácter vinculante y tienen mero carácter
            informativo, por lo que no pueden considerarse como documentos
            electorales que definan una elección.
          </p>
          <p>
            Los porcentajes se calculan y muestran con reducción a 2 dígitos a
            la derecha del separador decimal (término matemático: truncamiento a
            2 decimales).
          </p>
          <p>
            Es importante tener en cuenta que, el concepto de agrupación
            política utilizado incluye a los partidos y movimientos políticos
            con personería jurídica, grupos significativos de ciudadanos y
            coaliciones entre estos.
          </p>
        </TextContainer>
      </div>
    </FooterContainer>
  );
};

export default FooterLayout;

const SLogoRegistraduria = styled.div`
  display: flex;
  justify-content: center;
  & img {
    height: 80px;
    vertical-align: middle;
  }
  @media (max-width: 1024px) {
    padding: 0 15px;
  }
  @media (max-width: ${responsive.mobile}px) {
    flex-direction: column;
    row-gap: 20px;
  }

  @media print {
    display: none;
  }

`;

const SPrint = styled.div`
  display: none;
  justify-content: center;
  align-items: center;

  & img {
    width: 100%;
    vertical-align: middle;
  }

  @media print {
    display: flex;
  }

`;

const FooterContainer = styled(({ ...rest }) => <footer {...rest} />)`
  background: #F5F8FD;
  display: grid;
  margin-top: 1.6rem;
  padding: 4.4rem;
  width: 100%;
  grid-template-columns: 2fr 3fr;
  gap:2rem;
  box-sizing:border-box;
  @media (max-width: ${responsive.tablet}px) {
    grid-template-columns: auto;
    row-gap: 20px;
    width: 100%;
  }
  @media print {
  }
`;

const TextContainer = styled.div`
  color: #003057;
  font-size: 1.4rem;
  @media print {
    color: black;
  }
`;
